export const Eye = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00074 13.6569 9.00074 12C9.00074 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7545 11.5404C16.9131 2.81979 7.08837 2.81989 2.247 11.5405C2.08954 11.8242 2.08954 12.1759 2.247 12.4596C7.08837 21.1802 16.9131 21.1801 21.7545 12.4595C21.9119 12.1758 21.9119 11.8241 21.7545 11.5404Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Eye
